export function queryString(obje) {
	function queryArray(obj) {
		let par = Object.keys(obj);
		let res = [];
		par.map((k) => {
			if (obj[k] instanceof Array) {
				let arr = obj[k];

				return arr.map((z, ind) => {
					return res.push(encodeURIComponent(k) + "=" + encodeURIComponent(arr[ind]));
				});
			} else if (obj[k] instanceof Object) {
				return (res = [...res, ...queryArray(obj[k])]);
			} else {
				return res.push(encodeURIComponent(k) + "=" + encodeURIComponent(obj[k]));
			}
		});

		return res;
	}

	return "?" + queryArray(obje).join("&");
}

export default async function fetchServer(route, method, dati, authContextValue) {
	return new Promise((res, rej) => {
		let interfacce =
			authContextValue.interfacce?.length > 0 ? ["ph", authContextValue.interfacce] : ["ph"];

		let data = {
			method: method,
			headers: {
				authorization: "Bearer " + authContextValue.token,
				interfacce: interfacce,
				version: "v1",
			},
		};
		if (method === "GET") {
			route = route + queryString(dati);
		} else if (method === "POST" || method === "PUT" || method === "DELETE" || method === "PATCH") {
			data.headers["Content-Type"] = "application/json";

			data.body = JSON.stringify(dati);
		} else if (method === "FORMDATA") {
			data.method = "POST";
			data.body = dati;
		} else if (method === "GETROUTEID") {
			if (/[0-9]/.test(dati)) {
				route = route + "/" + dati;
				data.method = "GET";
			} else {
				rej("Id non valido");
			}
		}

		fetch(import.meta.env.VITE_SERVERIP + route, data)
			.then((response) => {
				if (!response.ok) {
					if (response.status === 401) {
						if (!!authContextValue.logout) {
							authContextValue.logout();
						}
						rej(new Error("Sessione Scaduta"));
					} else if (response.status === 403) {
						rej(new Error("Non hai i privilegi necessari per eseguire questa operazione"));
					} else if (response.status === 502) {
						rej(new Error("Non è possibile raggiungere il Server"));
					} else {
						response.json().then((err) => {
							rej(err);
						});
					}
				} else {
					response.json().then((rs) => {
						res(rs);
					});
				}
			})
			.catch((err) => {
				rej(err);
			});
	});
}

export async function fetchServerBlob(route, method, dati, authContextValue) {
	return new Promise((res, rej) => {
		let data = {
			method: method,
			headers: {
				authorization: "Bearer " + authContextValue.token,
				interfacce: authContextValue.interfacce,
				version: "v1",
			},
		};
		if (method === "GET") {
			route = route + queryString(dati);
		} else if (method === "POST") {
			data.headers["Content-Type"] = "application/json";

			data.body = JSON.stringify(dati);
		} else if (method === "FORMDATA") {
			data.method = "POST";
			data.body = dati;
		}

		fetch(import.meta.env.VITE_SERVERIP + route, data)
			.then((response) => {
				if (!response.ok) {
					if (response.status === 401) {
						authContextValue.logout();
						rej(new Error("Sessione Scaduta"));
					} else if (response.status === 403) {
						rej(new Error("Non hai i privilegi necessari per eseguire questa operazione"));
					} else {
						response.json().then((err) => {
							rej(err);
						});
					}
				} else {
					response.blob().then((rs) => {
						res(rs);
					});
				}
			})
			.catch((err) => {
				rej(err);
			});
	});
}
